import productcategories from "./productcategories"
import axios from 'axios';
import _ from 'lodash';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    filter: "",
    addNew: false,
    columns : {
        inbox: [
            {
                key:"id",
                label: "id",
                display : true,
            },
            {
                key:"status",
                label: "status",
                display : true,
            },
            {
                key : "kooi_id",
                label : "kooi_id",
                display : true
            },
            {
                key : "data.subject",
                label : "subject",
                display : true
            }
        ],
        outgoing: [
            {
                key:"id",
                label: "id",
                display : true,
            },
            {
                key:"status",
                label: "status",
                display : true,
            },
            {
                key : "kooi_id",
                label : "kooi_id",
                display : true
            },
            {
                key : "data.subject",
                label : "subject",
                display : true
            },
            {
                key : "outgoing_at",
                label : "outgoing_at",
                display : true
            },
        ],
        sent: [
            {
                key:"id",
                label: "id",
                display : true,
            },
            {
                key:"status",
                label: "status",
                display : true,
            },
            {
                key : "kooi_id",
                label : "kooi_id",
                display : true
            },
            {
                key : "data.subject",
                label : "subject",
                display : true
            },
            {
                key : "outgoing_at",
                label : "outgoing_at",
                display : true
            },
            {
                key : "sent_at",
                label : "sent_at",
                display : true
            },
        ]
    },
    loaded :false,
    isSavingNew : false,
    infinity : {
        clear: false,
        search : "",
        columns : ['kooi_id', 'status', "document_type", "document_id"],
        allLoaded : false,
        loading : true,
        loadingMore : false,
        take : 50,
    },
    workingOn : [],
})

  // getters
  const getters = {
    getById :(state) => (id) =>{
        return state.list[state.list.findIndex(item => item.id == id)]
    }
  }

  // actions
  const actions = {

    async setViewed({commit, state, rootState}, data){
        return await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/email/viewed/" + data.id, {viewed : data.view});
    },
    async update({commit, state, rootState}, data){
        commit("workingOn", data.product.id);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/products/" + data.product.id, data).then(response => {
            commit("update", response.data.data);
        })
        commit("doneWorkingOn", data.id);
    },
    async store({commit, state, rootState}, data){
        commit("isSavingNew", true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails", data).then(response => {
            commit("store", response.data.data);
        })
        commit("isSavingNew", false);
    },
    async load({commit, state, rootState}){
        if(state.infinity.allLoaded == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                var skip = state.list.length;
            }
        }
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/emails", {params: {filter: state.filter, skip : skip, take: state.infinity.take, search : state.infinity.search}}).then((response) => {
            if(_.isArray(response.data)){
                commit("set", response.data);
            }
            commit("loaded", true);
            commit("infinityLoading", false);
        })
    },
    async refreshUid({commit, state, rootState}, data){
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails/" + data.id + "/refreshMail", data).then(response => {
            commit("update", response.data.data);
        })
    }
  }

  // mutations
  const mutations = {
      clean(state){
        state.list = [];
        state.loaded = false;
        state.infinity.allLoaded =false;
        state.infinity.clear = true;
        state.infinity.search = "";
        state.workingOn = [];
      },
      update(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index >= 0){
            state.list[index] = data;
        }
      },
      store(state, data){
          state.list.unshift(data);
      },
      loaded(state, status){
          state.loaded = status;
      },
      set(state, list){
        for (const row in list) {
            state.list.push(list[row]);
        }
      },
      setSearch(state, search){
        state.infinity.loading = true;
        state.infinity.allLoaded = false;
        state.infinity.search = search;
        state.infinity.clear = true;
    },
    infinityLoading(state, status){
        state.infinity.loading = status;
    },
    setSearchValue(state, value){
        state.infinity.search = value;
    },
    workingOn(state, id){
        if(state.workingOn.findIndex(item => item == id) < 0){
            state.workingOn.push(id);
        }
        },
    doneWorkingOn(state, id){
        var index = state.workingOn.findIndex(item => item == id);
        if(index >= 0){
            state.workingOn.splice(index, 1);
        }
    },
    isSavingNew(state, status){
        state.isSavingNew = status;
    },
    filter(state, filter){
        state.filter = filter;
    },
    clearList(state) {
        state.list = [];
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        productcategories
    }
  }
